import * as Styled from '../../policy.styled';

export default function UseRestrictionPolicyTh() {
  return (
    <Styled.MainWrapper style={{ marginTop: 40 }}>
      <h3 style={{ marginBottom: '40px' }}>นโยบายการให้บริการ</h3>
      นโยบายการให้บริการฉบับนี้จัดทำขึ้นโดยบริษัท Bubbletap จำกัด (ต่อไปนี้เรียกว่า “บริษัท”)
      เพื่อกำหนดหลักเกณฑ์ในการให้บริการต่าง ๆ ที่บริษัทให้บริการ ได้แก่ <strong>‘BubbleChat’</strong> ‘Reward’
      และบริการอื่น ๆ (ต่อไปนี้เรียกรวมว่า “บริการ”) โดยมีวัตถุประสงค์เพื่อให้การจัดการกับปัญหาที่อาจเกิดขึ้นภายในบริการ
      รวมถึงการดูแลคอนเทนต์ที่เกี่ยวข้องเป็นไปอย่างเป็นระบบและมีมาตรฐานเดียวกัน (อ้างอิงตามข้อที่ 2 วรรค 2
      ของข้อกำหนดการให้บริการ)
      <br />
      <br />
      นโยบายการให้บริการนี้ระบุรายละเอียดข้อกำหนดที่ผู้ใช้บริการทุกท่านต้องปฏิบัติตาม หากไม่ปฏิบัติตามนโยบายดังกล่าว
      บริษัทอาจกำหนดมาตรการลงโทษหรือจำกัดสิทธิในการใช้บริการทั้งหมดของบริษัท
      ทั้งนี้ขึ้นอยู่กับลักษณะและความรุนแรงของการละเมิด จึงขอให้ผู้ใช้บริการอ่านและทำความเข้าใจอย่างละเอียด
      <br />
      <br />
      นอกจากนี้ ความหมายของคำศัพท์ที่ใช้ในนโยบายการให้บริการฉบับนี้
      ให้ถือเป็นไปในทำนองเดียวกันกับที่ระบุไว้ในข้อกำหนดการใช้บริการ
      <br />
      <br />
      บริษัทมุ่งมั่นที่จะพัฒนานโยบายที่เกี่ยวข้องกับบริการอย่างต่อเนื่อง โดยเปิดโอกาสให้สมาชิกได้แสดงความคิดเห็น
      เพื่อปรับปรุงนโยบายให้เหมาะสมและเป็นธรรม ในกรณีที่มีการเปลี่ยนแปลงนโยบาย บริษัทจะแจ้งให้ทราบล่วงหน้าอย่างน้อย 7
      วัน ผ่านทางประกาศในการให้บริการ
      <p>ข้อที่ 1 สิทธิและหน้าที่ของสมาชิก</p>
      <ol>
        ① สิทธิของสมาชิก
        <br />
        สมาชิกสามารถสอบถามข้อมูลหรือแจ้งปัญหาที่เกี่ยวข้องกับการใช้บริการผ่านช่องทางศูนย์บริการลูกค้าออนไลน์
        <br />
        <br />② หน้าที่ของสมาชิก
        <ol>
          <li>
            สมาชิกจะต้องไม่กระทำการใด ๆ ภายในบริการที่ขัดต่อกฎหมาย ข้อกำหนดในการให้บริการ
            หรือนโยบายการดำเนินงานของบริษัท รวมถึงต้องไม่กระทำการใด ๆ ที่รบกวนหรือขัดขวางการใช้บริการของสมาชิกท่านอื่น
            หากสมาชิกฝ่าฝืนข้อกำหนดดังกล่าว บริษัทขอสงวนสิทธิ์ในการจำกัดหรือระงับการใช้บริการของสมาชิก
            โดยไม่จำเป็นต้องแจ้งให้ทราบล่วงหน้า ทั้งนี้เป็นไปตามระเบียบภายในของบริษัท
          </li>
          <li>
            สมาชิกมีหน้าที่ตรวจสอบ และติดตามข้อกำหนดการใช้บริการ นโยบายการให้บริการ ตลอดจนประกาศต่าง ๆ
            ที่เผยแพร่บนเว็บไซต์ของบริษัทอย่างสม่ำเสมอ หากเกิดความเสียหายอันเนื่องมาจากการละเลยไม่ตรวจสอบข้อมูลเหล่านี้
            บริษัทอาจไม่สามารถให้ความช่วยเหลือหรือรับผิดชอบใด ๆ ได้
          </li>
          <li>
            หากสมาชิกกระทำการละเมิดสิทธิในทรัพย์สินทางปัญญา เช่น ละเมิดลิขสิทธิ์หรือสิทธิบัตรของบริษัทหรือบุคคลภายนอก
            ก่อให้เกิดความเสียหายต่อชื่อเสียง หรือขัดขวางการดำเนินงานของบริษัท หรือมีการกระทำที่ฝ่าฝืนกฎหมายอื่นใด
            สมาชิกอาจถูกจำกัดหรือระงับสิทธิในการใช้บริการ และอาจต้องรับผิดทั้งทางแพ่งและอาญาตามที่กฎหมายกำหนด
          </li>
        </ol>
      </ol>
      <p>ข้อที่ 2 การจำกัดการใช้บริการ</p>
      ในกรณีที่ผู้ใช้บริการของบริษัทได้กระทำการที่ฝ่าฝืนนโยบายการให้บริการตามที่ระบุไว้ในข้อที่ 3
      บริษัทอาจดำเนินการจำกัดการใช้บริการตามระดับขั้นดังต่อไปนี้ โดยพิจารณาจากความถี่ของการกระทำผิด
      หรือความรุนแรงของการละเมิดตามที่บริษัทเห็นสมควร ทั้งนี้ การจำกัดการใช้บริการไม่จำเป็นต้องดำเนินตามระดับขั้น
      และอาจมีการบังคับใช้มาตรการขั้นสูงทันทีตามดุลยพินิจของบริษัท
      <br />
      <br />
      <ol>
        ① การจำกัดการใช้บริการทั่วไป
        <li>ระดับที่ 1: แจ้งเตือนผู้ใช้เกี่ยวกับนโยบาย และดำเนินการซ่อนหรือลบเนื้อหาที่เกี่ยวข้อง</li>
        <li>
          ระดับที่ 2: ซ่อน หรือลบเนื้อหาที่เกี่ยวข้อง และระงับการใช้งานฟังก์ชันคอมมูนิตี้ หรือโซเชียลมีเดีย
          ภายใต้การดูแลของบริษัท เป็นระยะเวลาไม่เกิน 7 วัน
        </li>
        <li>ระดับที่ 3: ซ่อนหรือลบเนื้อหาที่เกี่ยวข้อง และระงับการใช้งานบัญชีผู้ใช้เป็นระยะเวลาไม่เกิน 7 วัน</li>
        <li>ระดับที่ 4: ซ่อนหรือลบเนื้อหาที่เกี่ยวข้อง และระงับการใช้งานบัญชีผู้ใช้เป็นระยะเวลาไม่เกิน 30 วัน</li>
        <li>ระดับที่ 5: ซ่อนหรือลบเนื้อหาที่เกี่ยวข้อง และระงับการใช้งานบัญชีผู้ใช้อย่างถาวร</li>
      </ol>
      <ol>
        ② การจำกัดการใช้บริการการเผยแพร่ผลงานสร้างสรรค์ เช่น ตัวละคร AI, เนื้อเรื่อง AI, ธีม AI ฯลฯ (เรียกรวมว่า
        “ทรัพย์สิน AI”)
        <li>ระดับที่ 1: แจ้งเตือนเกี่ยวกับนโยบาย และดำเนินการซ่อนหรือลบทรัพย์สิน AI ที่เกี่ยวข้อง</li>
        <li>
          ระดับที่ 2: ซ่อนหรือลบทรัพย์สิน AI ที่เกี่ยวข้อง
          และระงับการใช้ฟังก์ชันที่เกี่ยวข้องกับการสร้างหรือใช้งานคอนเทนต์ เป็นระยะเวลาไม่เกิน 7 วัน
        </li>
        <li>ระดับที่ 3: ซ่อนหรือลบทรัพย์สิน AI ที่เกี่ยวข้อง และระงับการใช้งานบัญชีผู้ใช้เป็นระยะเวลาไม่เกิน 7 วัน</li>
        <li>ระดับที่ 4: ซ่อนหรือลบทรัพย์สิน AI ที่เกี่ยวข้อง และระงับการใช้งานบัญชีผู้ใช้เป็นระยะเวลาไม่เกิน 30 วัน</li>
        <li>ระดับที่ 5: ซ่อนหรือลบทรัพย์สิน AI ที่เกี่ยวข้อง และระงับการใช้งานบัญชีผู้ใช้อย่างถาวร</li>
      </ol>
      <ol>
        ③ การยื่นคัดค้านการจำกัดการใช้บริการ
        <li>ผู้ใช้มีสิทธิยื่นคัดค้านการจำกัดการใช้บริการภายในระยะเวลาที่กำหนดสำหรับการชี้แจงเหตุผล </li>
        <li>
          สำหรับระดับที่ 1 และระดับที่ 5 ผู้ใช้มีสิทธิยื่นคัดค้านได้ภายใน 30 วัน ระดับที่ 2 ถึงระดับที่ 4
          สามารถยื่นคัดค้านได้ภายในระยะเวลาที่ถูกจำกัดการใช้บริการ
        </li>
        <li>
          บริษัทจะดำเนินการตรวจสอบคำคัดค้านภายใน 3 ถึง 5 วันทำการ นับจากวันที่ได้รับคำร้อง
          และหากเห็นว่าเหตุผลมีความเหมาะสม จะดำเนินการยกเลิก หรือปรับลดมาตรการจำกัดการใช้งานโดยทันที
        </li>
        <li>
          หากระหว่างการยื่นคัดค้าน ผู้ใช้มีพฤติกรรมไม่เหมาะสม เช่น ใช้ถ้อยคำหยาบคาย ส่อไปในทางลามก อนาจาร ข่มขู่
          หรือกระทำการใด ๆ ที่รบกวนการดำเนินงานของบริษัท บริษัทอาจระงับ
          หรือยุติกระบวนการพิจารณาคำคัดค้านดังกล่าวโดยไม่ต้องแจ้งล่วงหน้า
        </li>
      </ol>
      <p>ข้อที่ 3 พฤติกรรมที่เข้าข่ายถูกจำกัดการใช้บริการ</p>
      ผู้ใช้บริการที่กระทำการตามที่ระบุไว้ด้านล่างนี้
      อาจเข้าข่ายเป็นเหตุให้บริษัทดำเนินมาตรการจำกัดการใช้บริการตามที่ระบุไว้ในข้อ 2
      <br />
      <br />
      <ol>
        ① พฤติกรรมที่เกี่ยวข้องกับการถูกจำกัดในการใช้บริการ
        <li>
          การละเมิดข้อมูลส่วนบุคคล
          <ol>
            <li>การเปิดเผยข้อมูลของผู้อื่นโดยไม่ได้รับอนุญาต</li>
            <li>การใช้บัญชีของสมาชิกท่านอื่นโดยมิชอบ</li>
            <li>
              การโอนบัญชีให้บุคคลอื่น หรือแชร์บัญชีกับผู้อื่น ซึ่งมีเหตุอันควรสงสัยว่าเป็นการใช้งานที่ไม่ชอบด้วยกฎหมาย
            </li>
            <li>การเก็บรวบรวม จัดเก็บ หรือเปิดเผยข้อมูลส่วนบุคคลของสมาชิกท่านอื่นโดยไม่ได้รับความยินยอม</li>
          </ol>
        </li>
        <li>
          การแฮ็กระบบ
          <ol>
            <li>การดัดแปลง UUID ผ่านการแฮ็กโทรศัพท์มือถือ เพื่อหลีกเลี่ยงข้อจำกัด และเข้าถึงบริการ</li>
            <li>การดัดแปลงโปรแกรมของบริษัท หรือการแฮ็กเซิร์ฟเวอร์ โดยไม่ได้รับอนุญาตอย่างเป็นทางการจากบริษัท</li>
            <li>
              การใช้ช่องโหว่หรือข้อบกพร่องของระบบที่บริษัทอาจยังไม่ทราบหรือยังไม่ได้แก้ไข
              เพื่อเข้าถึงข้อมูลหรือบริการโดยมิชอบ รวมถึงการปลอมแปลงหรือแก้ไขข้อมูล
            </li>
            <li>
              การใช้โปรแกรมอัตโนมัติ หรือวิธีการอื่นใดที่ไม่ได้เป็นไปตามการใช้งานของบริการ
              ซึ่งส่งผลให้เกิดภาระบนเซิร์ฟเวอร์และรบกวนการดำเนินงานของบริษัท
            </li>
          </ol>
        </li>
        <li>
          การกระทำเพื่อแสวงหาผลประโยชน์ทางการค้าโดยผิดกฎหมาย
          <ol>
            <li>การโฆษณาเว็บไซต์ผิดกฎหมาย หรือเว็บไซต์ที่เกี่ยวข้องกับการพนัน</li>
            <li>การจำหน่ายหรือโปรโมตสินค้าผิดกฎหมาย</li>
            <li>การดำเนินกิจกรรมทางการค้าโดยไม่ได้รับอนุญาตจากบริษัทหรือขัดต่อแนวทางการใช้งานที่กำหนด</li>
            <li>
              การส่งข้อมูลโฆษณา หรืออีเมลสแปม (Spam Mail) ที่อาจรบกวนการดำเนินงานของการบริการ
              หรือส่งไปยังผู้รับโดยฝ่าฝืนความประสงค์ที่ได้แสดงไว้อย่างชัดเจนว่าไม่ต้องการรับ
            </li>
            <li>การกระทำที่สามารถพิจารณาได้อย่างสมเหตุสมผลว่าเกี่ยวข้องกับอาชญากรรม</li>
            <li>การกระทำอื่นใดที่ขัดต่อกฎหมายที่เกี่ยวข้อง หรือเป็นการกระทำที่ผิดกฎหมายหรือไม่เป็นธรรม</li>
          </ol>
        </li>
        <li>
          การละเมิดลิขสิทธิ์
          <ol>
            <li>
              การโพสต์ ใช้งาน หรือเผยแพร่ข้อมูลที่ละเมิดสิทธิในทรัพย์สินทางปัญญา เช่น สิทธิบัตร เครื่องหมายการค้า
              ความลับทางการค้า ลิขสิทธิ์ หรือสิทธิในทรัพย์สินทางปัญญาอื่นของบริษัท สมาชิกท่านอื่น หรือบุคคลที่สาม
            </li>
            <li>
              การคัดลอก เผยแพร่
              หรือใช้ข้อมูลที่ได้จากการใช้บริการของบริษัทเพื่อวัตถุประสงค์ทางการค้าโดยไม่ได้รับอนุญาตหรือความยินยอมจากบริษัท
            </li>
            <li>การให้ข้อมูลหรือวิธีการที่สามารถใช้ในการเข้าถึงหรือดาวน์โหลดเนื้อหาละเมิดลิขสิทธิ์อย่างผิดกฎหมาย</li>
            <li>
              การแชร์ผลงานของผู้อื่น เช่น รายการโทรทัศน์ เพลง ภาพยนตร์ การ์ตูน ฯลฯ โดยไม่ได้รับความยินยอมจากเจ้าของผลงาน
            </li>
            <li>การละเมิดสิทธิในเครื่องหมายการค้า สิทธิบัตรการออกแบบ ฯลฯ ของบุคคลอื่นโดยไม่ได้รับอนุญาต</li>
            <li>การกระทำใด ๆ ที่เกี่ยวข้องกับเนื้อหาที่ได้รับการแจ้งเรื่องการละเมิดลิขสิทธิ์จากเจ้าของสิทธิ</li>
            <li>การกระทำอื่นใดที่เข้าข่ายละเมิดลิขสิทธิ์นอกเหนือจากที่ระบุไว้ข้างต้น</li>
          </ol>
        </li>
        <li>
          การรบกวนการใช้บริการ
          <ol>
            <li>
              การใช้คำหยาบคาย วาจาหยาบ วาจาที่สร้างความรู้สึกอับอาย ขยะแขยง หรือหวาดกลัว การโพสต์ข้อความซ้ำ ๆ การคุกคาม
              ฯลฯ ที่รบกวนการใช้บริการของสมาชิกคนอื่น
            </li>
            <li>
              การโพสต์เนื้อหาในปริมาณมากเกินสมควรในเวลาสั้น ๆ เพื่อจุดประสงค์ในการดึงการเข้าชมผ่านเครื่องมือค้นหา
              ซึ่งถือว่าเป็นเจตนาไม่สุจริต
            </li>
            <li>การโพสต์เนื้อหาที่ไม่มีแหล่งที่มาชัดเจน หรือการเผยแพร่ข่าวลือที่อาจก่อให้เกิดความเข้าใจผิด</li>
          </ol>
        </li>
        <li>
          การเผยแพร่เนื้อหาอนาจาร
          <ol>
            <li>การเชื่อมต่อ (link) ไปยังเว็บไซต์ลามกอนาจาร</li>
            <li>การแชร์ข้อมูลที่เกี่ยวข้องกับการค้าประเวณี</li>
          </ol>
        </li>
        <li>
          การกระทำที่ก่อให้เกิดความขัดแย้ง
          <ol>
            <li>
              การแสดงพฤติกรรมที่เลือกปฏิบัติ หรือส่งเสริมอคติต่อเพศ ศาสนา ความพิการ อายุ สถานะทางสังคม เชื้อชาติ ภูมิภาค
              หรืออาชีพ
            </li>
            <li>การกระทำที่มีลักษณะยุยงหรือปลุกระดมทางการเมือง</li>
            <li>การกระทำอื่นใดที่ส่งเสริมความขัดแย้งหรือการเลือกปฏิบัติ นอกเหนือจากที่ระบุไว้ข้างต้น</li>
          </ol>
        </li>
        <li>
          การโพสต์เนื้อหา
          <ol>
            <li>การลงทะเบียนหรือแก้ไขโพสต์ด้วยข้อมูลเท็จ</li>
            <li>การโพสต์เนื้อหาที่มีข้อมูลเกี่ยวกับการใช้งาน หรือการแจกจ่ายโปรแกรมที่ผิดปกติหรือผิดกฎหมาย</li>
            <li>การเขียนโพสต์โดยใช้ผลงานของผู้อื่นโดยไม่ได้รับอนุญาตล่วงหน้า</li>
            <li>การโพสต์ข้อมูลหรือวิธีการที่เกี่ยวข้องกับการได้มาซึ่งเนื้อหาที่ละเมิดลิขสิทธิ์จากแหล่งที่ผิดกฎหมาย</li>
            <li>การโพสต์ข้อความเดิมซ้ำ ๆ อย่างต่อเนื่อง จนเป็นการรบกวนการใช้งานของผู้ใช้รายอื่น</li>
            <li>การโพสต์เนื้อหาอนาจารหรือข้อมูลเกี่ยวกับการค้าประเวณี</li>
            <li>การโพสต์เนื้อหาที่ดูหมิ่น ใส่ร้าย หรือใช้คำหยาบคายต่อผู้อื่น</li>
            <li>
              การเขียนเนื้อหาที่เลือกปฏิบัติหรือส่งเสริมอคติต่อเพศ ศาสนา ความพิการ อายุ สถานะทางสังคม เชื้อชาติ ภูมิภาค
              หรืออาชีพ
            </li>
            <li>การโพสต์เนื้อหาที่มีลักษณะเป็นการปลุกระดมหรือยุยงทางการเมือง</li>
            <li>การเขียนเนื้อหาที่รบกวนการใช้บริการของผู้อื่นหรือมีเนื้อหาที่ผิดกฎหมาย นอกเหนือจากที่ระบุไว้ข้างต้น</li>
          </ol>
        </li>
        <li>
          อื่น ๆ
          <ol>
            <li>การแอบอ้างเป็นบริษัทหรือบุคลากรของบริษัท</li>
            <li>การกระทำที่ทำให้บริษัทหรือบุคคลที่สามเสียชื่อเสียงหรือได้รับความเสียหาย</li>
            <li>การแก้ไขข้อมูลที่บริษัทเป็นผู้เผยแพร่</li>
            <li>
              การตั้งชื่อผู้ใช้งาน โพสต์ หรือความคิดเห็นที่มีเจตนาแอบอ้างบริษัท บริษัทอื่น หรือเจ้าของลิขสิทธิ์
              เพื่อวัตถุประสงค์ที่ไม่เกี่ยวข้องกับการใช้งานบริการอย่างเหมาะสม
            </li>
            <li>
              การสมัครสมาชิกใหม่หลังจากได้แสดงเจตจำนงที่จะไม่ใช้บริการต่อ และได้ยอมรับเงื่อนไขการไม่ให้สมัครใหม่อีก
            </li>
            <li>การกระทำอื่นใดที่ขัดต่อข้อห้ามในบริการ นอกเหนือจากที่ระบุไว้ข้างต้น</li>
          </ol>
        </li>
      </ol>
      <ol>
        ② ข้อจำกัดเกี่ยวกับการโพสต์ผลงานสร้างสรรค์ และทรัพย์สิน AI (AI Assets)
        <li>
          การกระทำ
          <ol>
            <li>เผยแพร่เนื้อหาสำหรับผู้ใหญ่</li>
            <li>เผยแพร่เนื้อหาสำหรับผู้ใหญ่โดยไม่แสดงเครื่องหมายหรือคำเตือนที่เหมาะสม</li>
            <li>เปลี่ยนแปลงหรือบิดเบือนการจัดระดับอายุของคอนเทนต์สำหรับผู้ใหญ่โดยพลการ</li>
            <li>
              แสดงพฤติกรรมที่ไม่สามารถเผยแพร่ได้ตามข้อกำหนดของกฎหมายด้านการสื่อสาร
              หรือแสดงพฤติกรรมที่ขัดต่อบรรทัดฐานของสังคมอย่างชัดเจน
            </li>
            <li>แสดงภาพอวัยวะเพศหรือการกระทำทางเพศโดยไม่มีการปิดบัง (เช่น การเบลอที่ไม่สามารถปกปิดรูปร่างได้)</li>
            <li>
              กรณีอื่น ๆ ที่บริษัทพิจารณาแล้วว่าจำเป็นต้องดำเนินการโดยเร่งด่วนเนื่องจากเป็นการละเมิดกฎหมายที่เกี่ยวข้อง
            </li>
          </ol>
        </li>
        <li>
          การล่วงละเมิดเด็ก
          <ol>
            <li>
              มีเนื้อหาที่เด็กหรือเยาวชน (อายุต่ำกว่า 18 ปี ตามกฎหมายว่าด้วยการคุ้มครองทางเพศต่อเด็กและเยาวชน) ปรากฏตัว
              และมีส่วนร่วมในกิจกรรมทางเพศ ซึ่งขัดต่อบรรทัดฐานของสังคม
            </li>
            <li>แสดงบุคคลหรือภาพที่สามารถรับรู้ได้อย่างชัดเจนว่าเป็นเด็กหรือเยาวชน และเกี่ยวข้องกับกิจกรรมทางเพศ</li>
          </ol>
        </li>
        <li>
          เนื้อหาเกี่ยวกับความรุนแรง
          <ol>
            <li>
              การแสดงหรือส่งเสริมพฤติกรรมที่อาจนำไปสู่การบาดเจ็บรุนแรงหรือเสียชีวิต เช่น การทำร้ายตนเองหรือการฆ่าตัวตาย
              รวมถึงการทำให้ความรุนแรงทั้งทางร่างกายและจิตใจดูเป็นเรื่องปกติหรือสวยงาม
            </li>
            <li>
              การแสดงหรือทำให้การใช้ยาเสพติด อาวุธ หรือการก่ออาชญากรรม เช่น การผลิตระเบิดหรืออาวุธ ดูเป็นเรื่องน่าสนใจ
              หรือสมจริงเกินควรจนเป็นการยุยงให้กระทำผิด
            </li>
            <li>
              การแสดงฉากที่โหดร้ายและรุนแรง เช่น การลักพาตัว ค้ามนุษย์ ฆาตกรรม ทำร้ายร่างกาย ทรมาน ทำลายอวัยวะ
              หรือค้าขายอวัยวะ อย่างละเอียด หรือในลักษณะที่ส่งเสริมความรุนแรง
            </li>
            <li>
              การแสดงหรือสรรเสริญความรุนแรงต่อบุคคลในครอบครัว ผู้สูงอายุ หญิงตั้งครรภ์ ผู้พิการ เด็ก
              หรือผู้ที่อยู่ในสถานะเปราะบางทางสังคม ซึ่งอาจบั่นทอนหลักศีลธรรมอันดีของสังคม
            </li>
            <li>การดูหมิ่น เหยียดหยาม หรือส่งเสริมความเกลียดชังต่อเหยื่อในเหตุการณ์อาชญากรรมหรือเหตุการณ์จริง</li>
            <li>
              การแสดงภาพหรือเนื้อหาที่เกี่ยวข้องกับการฆ่าสัตว์ ทารุณกรรมสัตว์
              หรือซากสัตว์ในลักษณะที่สร้างความสะเทือนใจหรือขยะแขยง
            </li>
          </ol>
        </li>
        <li>
          การแสดงออกในเชิงเกลียดชัง
          <ol>
            <li>
              การแสดงออกหรือเผยแพร่เนื้อหาที่กระตุ้นให้เกิดความรุนแรงหรือความเกลียดชังต่อบุคคลหรือกลุ่มใดกลุ่มหนึ่ง
              โดยอ้างอิงถึง เชื้อชาติ ศาสนา อายุ เพศ ความพิการ สัญชาติ รสนิยมทางเพศ อัตลักษณ์ทางเพศ หรือค่านิยมทางสังคม
            </li>
            <li>การใช้คำพูดหรือเนื้อหาที่ทำให้ผู้ใช้งานคนอื่นรู้สึกไม่พอใจ รังเกียจ หรือเกลียดชัง</li>
            <li>การแสดงเนื้อหาที่ขัดต่อศีลธรรมอันดีหรือมีเจตนาให้เกิดความไม่สงบในสังคม</li>
          </ol>
        </li>
        <li>
          การชักจูงหรือแสดงเนื้อหาผิดกฎหมาย
          <ol>
            <li>การให้ข้อมูลหรือโพสต์เนื้อหาที่เกี่ยวข้องกับการค้าประเวณีหรือเนื้อหาลามกอนาจาร</li>
            <li>การให้ข้อมูลเกี่ยวกับการพนัน</li>
            <li>การให้ข้อมูลเกี่ยวกับผลิตภัณฑ์อาหารหรือยาที่ผิดกฎหมาย</li>
            <li>การให้ข้อมูลเกี่ยวกับซอฟต์แวร์หรือโค้ดที่ใช้สำหรับแฮกหรือเจาะระบบ</li>
            <li>เนื้อหาที่อาจถือเป็นการชี้แนะ ส่งเสริม หรือสนับสนุนให้ก่ออาชญากรรม</li>
            <li>
              การแอบอ้างเป็นผู้ดูแลหรือเจ้าหน้าที่ของเว็บไซต์
              หรือโพสต์เนื้อหาที่อาจทำให้ผู้ใช้เข้าใจผิดว่าเกี่ยวข้องกับบริษัท
            </li>
            <li>การแสดงเนื้อหาที่บรรยายถึงการวางแผนหรือปฏิบัติการผิดกฎหมายอย่างละเอียด</li>
            <li>การให้ข้อมูลที่ละเมิดกฎหมาย เช่น การเงินผิดกฎหมาย หรือการซื้อขายข้อมูลส่วนบุคคล</li>
          </ol>
        </li>
        <li>
          การโฆษณา
          <ol>
            <li>
              หากเป็นเนื้อหาโฆษณาตามกฎหมายว่าด้วยการโฆษณาและการแสดงฉลากสินค้า
              แต่ไม่ได้ระบุข้อความให้ชัดเจนเกี่ยวกับผลประโยชน์ทางเศรษฐกิจที่เกี่ยวข้อง
              เพื่อให้ผู้บริโภคสามารถรับรู้ได้อย่างชัดเจนว่าเป็นโฆษณา
            </li>
            <li>มีการโฆษณาโดยตรงหรือโดยอ้อมให้กับเว็บไซต์ผิดกฎหมาย หรือเว็บไซต์ที่มีลักษณะส่งเสริมการพนัน</li>
            <li>มีการโฆษณาโดยตรงหรือโดยอ้อมเกี่ยวกับผลิตภัณฑ์ที่ผิดกฎหมาย</li>
          </ol>
        </li>
        <li>
          ลิขสิทธิ์
          <ol>
            <li>เนื้อหาที่เผยแพร่ไม่ใช่ผลงานที่ผู้ใช้สร้างขึ้นเอง</li>
            <li>มีการใช้ผลงานที่มีลิขสิทธิ์โดยไม่ได้รับอนุญาตจากเจ้าของลิขสิทธิ์</li>
            <li>
              มีการนำบางส่วนหรือทั้งหมดของผลงานที่สามารถระบุได้อย่างชัดเจนว่าเป็นของผู้สร้างต้นฉบับมาใช้โดยไม่ได้รับอนุญาต
            </li>
            <li>
              มีการนำบางส่วนหรือทั้งหมดของผลงานที่สามารถระบุได้อย่างชัดเจนว่าเป็นของผู้สร้างต้นฉบับมาใช้โดยไม่ได้รับอนุญาต
            </li>
          </ol>
        </li>
        <li>
          รูปแบบของคอนเทนต์
          <ol>
            <li>มีการปรับแต่งหรือปลอมแปลงตัวเลขที่เกี่ยวข้องกับเนื้อหา เช่น จำนวนแชต จำนวนไลก์ เป็นต้น</li>
            <li>
              เนื้อหาไม่มีความสมบูรณ์ หรือไม่สอดคล้องกับวัตถุประสงค์ของบริการ เช่น
              เนื้อหาว่างเปล่าหรือไม่มีเนื้อหาที่มีสาระ
            </li>
            <li>เนื้อหาอื่นใดที่บริษัทพิจารณาแล้วว่าไม่เหมาะสมต่อการเผยแพร่ในบริการ</li>
          </ol>
        </li>
        <li>
          อื่น ๆ
          <ol>
            <li>เนื้อหาที่ดูหมิ่น กล่าวหา หรือทำลายชื่อเสียงของบริษัท สมาชิกท่านอื่น หรือบุคคลที่สาม</li>
            <li>การเผยแพร่เนื้อหา ข้อความ ภาพ หรือสัญลักษณ์ที่ขัดต่อความสงบเรียบร้อยหรือศีลธรรมอันดีของประชาชน</li>
            <li>
              เนื้อหาที่ขัดต่อหลักเกณฑ์ของสถาบันส่งเสริมอุตสาหกรรมสิ่งพิมพ์ และคณะกรรมการพิจารณาเนื้อหาสื่อของเกาหลี
            </li>
            <li>เนื้อหาที่เกี่ยวข้องหรืออาจเชื่อมโยงกับการกระทำผิดทางอาญา</li>
            <li>เนื้อหาที่ละเมิดลิขสิทธิ์หรือสิทธิอื่น ๆ ของบริษัทหรือบุคคลที่สาม</li>
            <li>การโพสต์โฆษณาหรือสื่อส่งเสริมการขายที่ไม่ได้รับอนุญาต</li>
            <li>การโพสต์เนื้อหาที่ไม่มีแหล่งที่มาชัดเจน หรือเผยแพร่ข่าวลือ</li>
          </ol>
        </li>
      </ol>
      <p>ข้อที่ 4 การจัดการระบบการรายงานการใช้งานบริการ</p>
      ① สมาชิกสามารถรายงานเนื้อหาที่ฝ่าฝืนกฎหมาย ข้อกำหนดการใช้บริการ หรือนโยบายการดำเนินงานฉบับนี้ต่อบริษัทได้ทุกเมื่อ
      หากตรวจพบว่าเนื้อหานั้นไม่เหมาะสม
      <br />
      <br />
      ② ในการรายงาน สมาชิกต้องส่งแหล่งที่มาของเนื้อหาที่ต้องการรายงาน (เช่น URL)
      พร้อมทั้งระบุเหตุผลในการรายงานอย่างชัดเจน
      ข้อมูลเหล่านี้จะถูกส่งต่อให้เจ้าหน้าที่ผู้รับผิดชอบของบริษัทเพื่อพิจารณาว่าควรมีการจำกัดหรือดำเนินการใด ๆ หรือไม่
      <br />
      <br />
      ③ หากบริษัทพิจารณาแล้วว่าเนื้อหาที่ถูกรายงานไม่ถือเป็นการละเมิดต่อกฎหมาย ข้อกำหนดการใช้งาน หรือนโยบายการดำเนินงาน
      แม้จะแตกต่างจากความคิดเห็นของผู้รายงาน ก็อาจไม่มีการดำเนินการใด ๆ กับเนื้อหาดังกล่าว
      <br />
      <br />
      ④ แม้บริษัทจะเคยพิจารณาเรื่องที่ถูกรายงานไปแล้ว
      แต่หากในภายหลังมีคำสั่งศาลหรือคำตัดสินจากหน่วยงานที่มีอำนาจซึ่งชี้ให้เห็นว่าการพิจารณาก่อนหน้านั้นไม่เหมาะสม
      บริษัทสามารถเปลี่ยนแปลงการตัดสินใจได้
      <br />
      <br />⑤ ในระหว่างขั้นตอนการตรวจสอบเนื้อหาที่ถูกรายงาน
      บริษัทอาจพิจารณาดำเนินมาตรการเพิ่มเติมต่อบัญชีของสมาชิกที่เกี่ยวข้อง เช่น การจำกัดการใช้งานบัญชี
      ทั้งนี้จะพิจารณาจากประวัติการใช้งานของสมาชิก ความรุนแรงของการละเมิด ข้อกำหนดและนโยบายที่เกี่ยวข้อง
      รวมถึงกฎหมายที่เกี่ยวข้อง
      <p>ข้อที่ 5 นโยบายบัญชีไม่เคลื่อนไหว (สำหรับสมาชิกที่ไม่ได้เข้าสู่ระบบเป็นเวลานาน)</p>
      ① หากสมาชิกไม่ได้เข้าสู่ระบบเป็นระยะเวลา 1 ปี
      ข้อมูลส่วนบุคคลของสมาชิกจะถูกแยกเก็บรักษาไว้อย่างปลอดภัยจากฐานข้อมูลหลัก
      <br />
      <br />② หากสมาชิกไม่ได้เข้าสู่ระบบเป็นระยะเวลา 4 ปี (นับจากวันที่เริ่มแยกเก็บข้อมูล)
      ข้อมูลส่วนบุคคลดังกล่าวจะถูกทำลายอย่างถาวร และสัญญาการใช้บริการจะถือเป็นสิ้นสุดโดยอัตโนมัติ
      <p>ข้อที่ 6 การห้ามขอคืนเงินในทางที่ผิด</p>
      ① การคืนเงินในทางที่ผิด หมายถึง การที่ผู้ใช้ซื้อสินค้าดิจิทัลหรือบริการของบริษัทโดยใช้สกุลเงินภายในระบบ
      (ตามข้อกำหนดในข้อ 2 วรรค 1 ของข้อตกลงการใช้งาน) แล้วใช้สินค้าหรือบริการดังกล่าวไปเรียบร้อยแล้ว
      ก่อนจะทำเรื่องขอคืนเงินผ่านช่องทางต่าง ๆ เช่น Google Play, Apple App Store หรือหน่วยงานอื่น
      เพื่อให้ได้เงินคืนจากสินค้าที่ใช้งานไปแล้ว การกระทำลักษณะนี้ถือเป็นการฉ้อโกงและขโมยทรัพย์สินดิจิทัล
      บริษัทจะถือว่าการกระทำนี้เป็นการละเมิดข้อตกลงการใช้งานและนโยบายการดำเนินงานของบริษัท
      <br />
      <br />
      ② ในกรณีที่สมาชิกใช้บริการไปในทางที่ผิดด้วยวิธีการที่ผิดกฎหมาย, ผิดจรรยาบรรณ หรือผิดศีลธรรม
      บริษัทอาจจำกัดการใช้งานบริการของสมาชิกรายดังกล่าวได้ โดยบริษัทจะไม่ชดเชยหรือคืนเงินใดๆ ทั้งสิ้น
      <br />
      <br />③ ผู้ใช้ที่มีส่วนเกี่ยวข้องกับการคืนเงินในทางที่ผิด จะถูกดำเนินการตามมาตรการดังต่อไปนี้
      <ol>
        <li>
          ดำเนินคดีทางกฎหมาย:
          บริษัทมีสิทธิ์ในการดำเนินการทางกฎหมายกับผู้ใช้ที่ถูกยืนยันว่ามีส่วนเกี่ยวข้องกับการคืนเงินในทางที่ผิด
          และสามารถฟ้องร้องทางแพ่งเพื่อเรียกคืนความเสียหายที่บริษัทได้รับ
        </li>
        <li>
          แบนถาวร: ผู้ใช้ที่เกี่ยวข้องกับการกระทำดังกล่าวจะถูกห้ามใช้งานแพลตฟอร์มของบริษัทโดยถาวร
          การแบนนี้ครอบคลุมถึงทุกบัญชีและอุปกรณ์ของผู้ใช้ และจะไม่สามารถใช้งานบริการใด ๆ ของบริษัทได้อีก
        </li>
      </ol>
      ④ นโยบายไม่ยอมรับโดยสิ้นเชิง (zero-tolerance policy) บริษัทมีนโยบายไม่ยอมรับการขอคืนเงินในทางที่ผิดโดยเด็ดขาด
      เพื่อคุ้มครองความโปร่งใส ความยุติธรรม และสิทธิของผู้ใช้งานรวมถึงผู้สร้างเนื้อหาภายในแพลตฟอร์ม
      <br />
      <br />⑤ หน้าที่ของผู้ใช้บริการ: การใช้บริการของบริษัทถือว่าผู้ใช้ยอมรับเงื่อนไขดังต่อไปนี้
      <ol>
        <li>จะไม่กระทำการใด ๆ ที่เข้าข่ายการขอคืนเงินในทางที่ผิด</li>
        <li>จะปฏิบัติตามข้อตกลงการใช้งานและนโยบายที่เกี่ยวข้องอย่างเคร่งครัด.</li>
        <li>แจ้งบริษัททันทีหากพบว่ามีผู้ใช้รายอื่นกระทำการลักษณะนี้</li>
      </ol>
    </Styled.MainWrapper>
  );
}
